<template>
  <div class="chat-page" v-if="userInfo" :style="chatPageStyle">
    <div class="chat" ref="messageContainer" @scroll="throttleScroll">
      <div v-for="(messages, prop, index) in groupMessagesByDate"
           :key="prop + index"
      >
        <div class="date-line">
          <span>{{$moment(prop).format('D MMM, YYYY')}}</span>
        </div>
        <Message
          v-for="(message, index) in messages"
          :key="message.id + index"
          :messageData="message"
          :owner="userInfo.userId === message.srcMemberId"
          :avatarsAndLogos="avatarsAndLogos"
        />
      </div>
    </div>
    <div class="chat-form">
      <ChatForm
        @sendNewMessage="sendNewMessage"
        @markAsReadMessage="markAsReadMessage"
        :showIcon="true"
      />
    </div>
  </div>
</template>

<script>
import Message from '@/components/elements/Message'
import ChatForm from '@/components/elements/ChatForm'
import ChatHub from '@/chatHub'
import { throttle } from 'lodash'
import { mapActions, mapState } from 'vuex'
import { trackEvent } from '@/utils/analytics'

export default {
  name: 'chat',
  components: { Message, ChatForm },
  data: () => ({
    limitMessage: 10,
    skipMessage: 0,
    chatPageStyle: {}
  }),
  mounted () {
    window.addEventListener('scroll', this.handleScrollChat)
    this.loadData()
    ChatHub.client.on('ReceiveUnreadMessageCountUpdate', (data) => {
      console.log('ReceiveUnreadMessageCountUpdate', data)
      this.$store.commit('chat/UPDATE_TOTAL_COUNT_UNREAD_MESSAGE', data)
    })
    ChatHub.client.on('ReceiveMessageUpdate', (data) => {
      console.log('ReceiveMessageUpdate', data)
      const messageExist = this.allMessages.find(message => message.id === data.id)
      if (!messageExist) {
        console.log('PUSH_NEW_MESSAGE')
        this.$store.commit('chat/PUSH_NEW_MESSAGE', data)
      }
      this.$nextTick(() => this.scrollDown())
      if (messageExist) {
        console.log('UPDATE_MESSAGE')
        this.$store.commit('chat/UPDATE_MESSAGE', data)
      }
    })
    this.updateChatPageStyle()
    window.addEventListener('resize', this.updateChatPageStyle)

    // ChatHub.client.onclose(function () {
    //   console.log('CHAT HUB WAS CLOSED')
    //   setTimeout(function () {
    //     ChatHub.client.start()
    //   }, 1500) // Restart connection after 1.5 seconds
    // })
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScrollChat)
    this.$store.state.chat.messages = []
    window.removeEventListener('resize', this.updateChatPageStyle)
  },
  methods: {
    ...mapActions('chat', ['getMessages', 'createMessage', 'markAsReadMsg']),
    loadData () {
      this.getMessages({ additionalParam: `?skip=${this.skipMessage}&limit=${this.limitMessage}&memberId=${this.$route.params.id}` }).then(() => {
        if (this.allMessages.length > 0) {
          this.scrollDown()
        }
      })
    },
    markAsReadMessage () {
      console.log('markAsReadMessage')
      const unReadMessages = this.allMessages.filter(message => {
        if (message.dstMemberId === this.userInfo.userId && !message.isRead) {
          return message
        }
      }).map(item => item.id)
      this.markAsReadMsg({ IDs: unReadMessages })
      // if (this.dashboardInfo.patient.id !== lastMessage[this.allMessages.length - 1].srcMemberId) {
      //   this.markAsReadMsg({ id: lastMessage[this.allMessages.length - 1].id })
      // }
    },
    sendNewMessage (text) {
      if (text.trim()) {
        const newMessage = {
          dstMemberId: this.$route.params.id,
          dstMemberType: 2,
          messageType: 0,
          message: text,
          extra: ''
        }
        this.createMessage(newMessage).then(() => {
          trackEvent(this, 'send_message', 'Chat', 'Message Was Send')

          this.scrollDown()
        })
        // ChatHub.client.invoke('SendMessage')
      }
    },
    scrollDown () {
      this.$nextTick(() => {
        if (this.$refs.messageContainer) { // && this.skipMessage === 0
          const container = this.$refs.messageContainer
          container.scrollTop = container.scrollHeight
        }
      })
    },
    throttleScroll: throttle(function (event) {
      this.handleScrollChat(event)
    }, 1000),
    handleScrollChat (event) {
      if (event.target.scrollTop < 40) {
        this.skipMessage += 10
        this.getMessages({ additionalParam: `?skip=${this.skipMessage}&limit=10` })
      }
    },
    updateChatPageStyle() {
      if (window.innerWidth < 1497 && window.innerWidth > 1198) {
        this.chatPageStyle = { minHeight: '100vh' }
      } else if (window.innerWidth < 1198) {
        this.chatPageStyle = { minHeight: '100vh' }
      } else {
        this.chatPageStyle = { minHeight: 'calc(100vh - 160px)' }
      }
    }
  },
  computed: {
    ...mapState({
      patients: state => state.patients.patient,
      allMessages: state => state.chat.messages,
      userInfo: state => state.userProfile
    }),
    groupMessagesByDate () {
      return this._.groupBy(this.allMessages, 'customDate')
    },
    avatarsAndLogos () {
      const obj = {}
      obj[this.userInfo.userId] = this.userInfo.defaultProfileIcon
      // obj[this.patients.organization.id] = this.dashboardInfo.organization.logoSmall
      obj[this.patients.id] = this.patients.profileAvatar
      return obj
    }
  },
  watch: {
    // allMessages (messages) {
    //   if (messages.length > 0) {
    //     this.scrollDown()
    //   }
    // }
  }
}
</script>

<style scoped lang="scss">
.chat-page {
  position: relative;
  border-radius: 16px;
  background-color: #FFFFFF;
  box-shadow: 0px 10px 20px 0px rgba(113, 128, 150, 0.06);
  margin-left: 6px;
  margin-top: 16px;
  overflow: hidden;

  .chat {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 127px;
    padding: 18px 25px 20px;
    margin-bottom: 25px;
    overflow-y: auto;

    .date-line {
      width: 100%;
      text-align: center;
      border-bottom: 1px solid rgba(166, 183, 212, 0.4);
      line-height: 1px;
      margin: 42px 0 32px;

      span {
        color: #A0AEC0;
        font-weight: 500;
        font-size: 14px;
        text-align: center;
        background-color: #FFFFFF;
        padding: 0 45px;
      }
    }
  }

  .chat-form {
    //height: 100px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    border-top: 1px solid rgba(166, 183, 212, 0.4);
    background-color: #FFFFFF;
    padding: 25px;
  }

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background-color: #FFFFFF;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #CBD5E0;
    border: 1px solid #CBD5E0;
    border-radius: 10px;
  }
}
</style>
